import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { FragnoActionMenu } from 'fragno/react';
import { useTranslation } from 'react-i18next';

const EmailRowActionMenu = ({
  email,
  onRemove,
  onResendVerification,
  onSetDefault,
  defaultEmailPending,
}) => {
  const { t } = useTranslation();

  const handleSelect = useCallback(
    (e) => {
      const { item } = e.detail || {};
      if (item?.value === 'remove') {
        onRemove(email);
      } else if (item?.value === 'resend') {
        onResendVerification(email);
      } else if (item?.value === 'setDefault') {
        onSetDefault(email);
      }
    },
    [email, onRemove, onResendVerification, onSetDefault],
  );

  const showResend =
    email.verification_status !== 'verified' &&
    email.verification_status !== 'verified_pending_review';

  const showSetDefault = !email.is_default;

  const items = useMemo(
    () => [
      {
        value: 'resend',
        label: t('walletEmails.actionResend'),
        hidden: !showResend,
      },
      {
        value: 'setDefault',
        label: t('walletEmails.actionSetDefault'),
        hidden: !showSetDefault,
        disabled: !!defaultEmailPending,
      },
      { value: 'remove', label: t('walletEmails.actionRemove') },
    ],
    [t, showResend, showSetDefault, defaultEmailPending],
  );

  return (
    <FragnoActionMenu
      items={items}
      onSelect={handleSelect}
      aria-label={t('walletEmails.actionMenuLabel', {
        email: email.address,
      })}
    />
  );
};

EmailRowActionMenu.propTypes = {
  email: PropTypes.shape({
    email_id: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    verification_status: PropTypes.string.isRequired,
    is_default: PropTypes.bool,
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
  onResendVerification: PropTypes.func.isRequired,
  onSetDefault: PropTypes.func.isRequired,
  defaultEmailPending: PropTypes.bool,
};

export default memo(EmailRowActionMenu);
